module.exports = __webpack_public_path__ + "static/media/view canteen item.82505683.svg";